import {Component, Input, EventEmitter, Output, OnDestroy, ChangeDetectorRef} from "@angular/core";
import {BugsnagLoggingService} from "../services/logging/bugsnag-logging.service";
import {IQuestionEntry} from "../api/data-model";
import {QuestionService} from "../services/question/question.service";
import {UserModelService} from "../services/usermodel/usermodel.service";
import {EventBus} from "../event/EventBus";
import {ComponentBase} from "../base/ComponentBase";
import {QuizService} from "../services/quiz/quiz.service";
import {RaEvent} from "../event/RaEvent";
import {StartQuizEvent, StopQuizEvent} from "../event/QuizEvents";
import {ActivityEventData} from "../event/ActivityEvent";
import {TimerStrategy} from "../services/configuration/timer.config";
import {RaVersion} from "../services/configuration/ra.version";
import {EnableExitButtonEvent, DisableExitButtonEvent} from "../event/ExitButtonEvents";
import {filter} from "rxjs/operators";

@Component({
   selector: "quiz",
   templateUrl: "./quiz.component.html",
   styleUrls: ["./quiz.component.scss"]
})
export class QuizComponent extends ComponentBase implements OnDestroy {

    @Input()
    set questionEntries(value: IQuestionEntry[]) {
        this._questionEntries = value;
    }

    get questionEntries(): IQuestionEntry[] {
        return this._questionEntries;
    }

    private _questionEntries: IQuestionEntry[] = [];
    private closingSequenceActivate: boolean = false;

    @Output()
    public complete = new EventEmitter();

    public currentQuestionEntry: IQuestionEntry;
    public currentQuestionId: number;

    constructor(private log: BugsnagLoggingService,
                private eventBus: EventBus,
                private questionService: QuestionService,
                private quizService: QuizService,
                private userModelService: UserModelService,
                private changeDetectorRef: ChangeDetectorRef) {
        super("QuizComponent");
        let sub = this.eventBus.pipe(filter((e: RaEvent) => e.type === StartQuizEvent.TYPE))
            .subscribe((e: StartQuizEvent) => {
                this.eventBus.startActivityEvent(new ActivityEventData({timing: TimerStrategy.question}));
                this.eventBus.next(new DisableExitButtonEvent());
                this.log.log(" Starting Quiz");
                this.startQuiz();
            });
        this.subscriptions.push(sub);
    }

    ngOnDestroy(): void {
        if (!this.closingSequenceActivate) {
            this.questionCloseCompletely(this.currentQuestionEntry);
        }
        super.ngOnDestroy();
    }

    private filterForCurrentQuestion(): IQuestionEntry {
        return this._questionEntries[this.currentQuestionId];
    }

    private startQuiz(): void {
        this.quizService.setQuizActive(true);
        this.questionEntries = this.questionService.retrieveQuiz();
        this.closingSequenceActivate = false;
        this.currentQuestionId = this.quizService.startingQuestionId;
        this.currentQuestionEntry = this.currentQuestionId > 0 ?
                                    this.filterForCurrentQuestion() : this._questionEntries[0];
    }

    public questionAutoClose(entry: IQuestionEntry): void {
        this.currentQuestionId++;
        if (this.currentQuestionId < this._questionEntries.length) {
            this.currentQuestionEntry = this.filterForCurrentQuestion();
        } else {
            this.questionCloseCompletely(entry);
        }
        this.changeDetectorRef.detectChanges();
    }

    public questionCloseCompletely(entry: IQuestionEntry): void {
        this.closingSequenceActivate = true;
        this.eventBus.endActivityEvent(new ActivityEventData({timing: TimerStrategy.question}));
        this.currentQuestionEntry = undefined;
        this.quizService.setQuizActive(false);
        this.eventBus.next(new StopQuizEvent());
        this.eventBus.next(new EnableExitButtonEvent());
    }

    public questionCorrect(entry: IQuestionEntry): void {
        if (this.currentQuestionId === Number(this._questionEntries[this._questionEntries.length - 1].id)) {
            this.complete.emit(true);
        }
    }

    public questionIncorrect(entry: IQuestionEntry): void {
        // TODO: something here?
    }
}
